import { translations } from '../../../translations'

export const ConfirmOrdersModal = {
  icon: 'history',
  title: translations.pt_PT.Modal.titleRestoreOrder,
  footerBtn: 'saveBtn',
  component: 'restoreOrder'
}



// WEBPACK FOOTER //
// ./src/skeletons/structures/setup/confirmOrdersModal.js